// src/components/sveden/Teachers.js
import { FiDownload } from 'react-icons/fi';

const Teachers = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">Педагогический состав</h2>
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <img
          src="/teacher.jpg"
          alt="Благодатская Юлия Юрьевна"
          className="w-48 h-48 object-cover rounded-full shadow-md border-2 border-gray-200"
          onError={(e) => (e.target.src = 'https://placehold.co/200x200?text=Фото')}
        />
        <div className="flex-1">
          <div className="flex items-center gap-3 flex-wrap">
            <h3 className="text-xl font-bold">Благодатская Юлия Юрьевна</h3>
            <a
              href="/documents/diploma.pdf"
              download
              className="inline-flex items-center gap-1 text-sm bg-blue-50 hover:bg-blue-100 text-blue-700 px-3 py-1.5 rounded-lg transition"
            >
              <FiDownload className="text-base" />
              Диплом (PDF)
            </a>
          </div>
          <p className="text-gray-600 mt-1">педагог по обществознанию</p>
          <div className="mt-3 space-y-1 text-gray-700">
            <p><strong>Образование:</strong> высшее. КГУ им. К.Э.Циолковского, 2011 год, квалификация – учитель истории; Институт управления, бизнеса и технологий, 2014 год, квалификация – бакалавр юриспруденции.</p>
            <p><strong>Опыт работы:</strong> 16 лет.</p>
            <p>Педагог участвует в реализации дополнительной общеразвивающей программы «Сложные вопросы обществознания».</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Teachers;